var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/config/csharp/config.json
var config_default = {
  irFilepath: "/fern/ir.json",
  output: {
    mode: {
      type: "github",
      repoUrl: "",
      version: "",
      publishInfo: {
        type: "nuget",
        registryUrl: "",
        packageName: "",
        apiKeyEnvironmentVariable: ""
      }
    },
    path: "/fern/output",
    publishingMetadata: null,
    snippetFilepath: "/fern/snippet.json",
    snippetTemplateFilepath: "/fern/snippet-templates.json"
  },
  publish: null,
  customConfig: {},
  workspaceName: "",
  organization: "",
  environment: {
    _type: "local"
  },
  dryRun: false,
  whitelabel: false,
  writeUnitTests: true,
  generateOauthClients: true,
  generatePaginatedClients: true
};

// src/config/go/config.json
var config_default2 = {
  irFilepath: "/fern/ir.json",
  output: {
    mode: {
      type: "github",
      repoUrl: "",
      version: "",
      publishInfo: null
    },
    path: "/fern/output",
    publishingMetadata: null,
    snippetFilepath: "/fern/snippet.json",
    snippetTemplateFilepath: "/fern/snippet-templates.json"
  },
  publish: null,
  customConfig: {},
  workspaceName: "",
  organization: "",
  environment: {
    _type: "local"
  },
  dryRun: false,
  whitelabel: false,
  writeUnitTests: true,
  generateOauthClients: true,
  generatePaginatedClients: true
};

// src/config/java/config.json
var config_default3 = {
  irFilepath: "/fern/ir.json",
  output: {
    mode: {
      type: "github",
      repoUrl: "",
      version: "",
      publishInfo: {
        type: "maven",
        registryUrl: "",
        coordinate: "",
        usernameEnvironmentVariable: "",
        passwordEnvironmentVariable: ""
      }
    },
    path: "/fern/output",
    publishingMetadata: null,
    snippetFilepath: "/fern/snippet.json",
    snippetTemplateFilepath: "/fern/snippet-templates.json"
  },
  publish: null,
  customConfig: {},
  workspaceName: "",
  organization: "",
  environment: {
    _type: "local"
  },
  dryRun: false,
  whitelabel: false,
  writeUnitTests: true,
  generateOauthClients: true,
  generatePaginatedClients: true
};

// src/config/php/config.json
var config_default4 = {
  irFilepath: "/fern/ir.json",
  output: {
    mode: {
      type: "github",
      repoUrl: "",
      version: "",
      publishInfo: null
    },
    path: "/fern/output",
    publishingMetadata: null,
    snippetFilepath: "/fern/snippet.json",
    snippetTemplateFilepath: "/fern/snippet-templates.json"
  },
  publish: null,
  customConfig: {},
  workspaceName: "",
  organization: "",
  environment: {
    _type: "local"
  },
  dryRun: false,
  whitelabel: false,
  writeUnitTests: true,
  generateOauthClients: true,
  generatePaginatedClients: true
};

// src/config/python/config.json
var config_default5 = {
  irFilepath: "/fern/ir.json",
  output: {
    mode: {
      type: "github",
      repoUrl: "",
      version: "",
      publishInfo: {
        type: "pypi",
        registryUrl: "https://pypi.org",
        packageName: "",
        usernameEnvironmentVariable: "",
        passwordEnvironmentVariable: ""
      }
    },
    path: "/fern/output",
    publishingMetadata: null,
    snippetFilepath: "/fern/snippet.json",
    snippetTemplateFilepath: "/fern/snippet-templates.json"
  },
  publish: null,
  customConfig: {},
  workspaceName: "",
  organization: "",
  environment: {
    _type: "local"
  },
  dryRun: false,
  whitelabel: false,
  writeUnitTests: true,
  generateOauthClients: true,
  generatePaginatedClients: true
};

// src/config/ruby/config.json
var config_default6 = {
  irFilepath: "/fern/ir.json",
  output: {
    mode: {
      type: "github",
      repoUrl: "",
      version: "",
      publishInfo: {
        type: "rubygems",
        registryUrl: "https://rubygems.org",
        packageName: "",
        apiKeyEnvironmentVariable: ""
      }
    },
    path: "/fern/output",
    publishingMetadata: null,
    snippetFilepath: "/fern/snippet.json",
    snippetTemplateFilepath: "/fern/snippet-templates.json"
  },
  publish: null,
  customConfig: {},
  workspaceName: "",
  organization: "",
  environment: {
    _type: "local"
  },
  dryRun: false,
  whitelabel: false,
  writeUnitTests: true,
  generateOauthClients: true,
  generatePaginatedClients: true
};

// src/config/swift/config.json
var config_default7 = {
  irFilepath: "/fern/ir.json",
  output: {
    mode: {
      type: "github",
      repoUrl: "",
      version: "",
      publishInfo: null
    },
    path: "/fern/output",
    publishingMetadata: null,
    snippetFilepath: "/fern/snippet.json",
    snippetTemplateFilepath: "/fern/snippet-templates.json"
  },
  publish: null,
  customConfig: {},
  workspaceName: "",
  organization: "",
  environment: {
    _type: "local"
  },
  dryRun: false,
  whitelabel: false,
  writeUnitTests: true,
  generateOauthClients: true,
  generatePaginatedClients: true
};

// src/config/typescript/config.json
var config_default8 = {
  irFilepath: "/fern/ir.json",
  output: {
    mode: {
      type: "github",
      repoUrl: "",
      version: "",
      publishInfo: {
        type: "npm",
        registryUrl: "https://registry.npmjs.org",
        packageName: "",
        tokenEnvironmentVariable: ""
      }
    },
    path: "/fern/output",
    publishingMetadata: null,
    snippetFilepath: "/fern/snippet.json",
    snippetTemplateFilepath: "/fern/snippet-templates.json"
  },
  publish: null,
  customConfig: {},
  workspaceName: "",
  organization: "",
  environment: {
    _type: "local"
  },
  dryRun: false,
  whitelabel: false,
  writeUnitTests: true,
  generateOauthClients: true,
  generatePaginatedClients: true
};

// src/EndpointProvider.ts
import { DynamicSnippetsGenerator as CSharp } from "@fern-api/csharp-dynamic-snippets";
import { DynamicSnippetsGenerator as Go } from "@fern-api/go-dynamic-snippets";
import { DynamicSnippetsGenerator as Java } from "@fern-api/java-dynamic-snippets";
import { DynamicSnippetsGenerator as PHP } from "@fern-api/php-dynamic-snippets";
import { DynamicSnippetsGenerator as Python } from "@fern-api/python-dynamic-snippets";
import { DynamicSnippetsGenerator as Ruby } from "@fern-api/ruby-dynamic-snippets";
import { DynamicSnippetsGenerator as Swift } from "@fern-api/swift-dynamic-snippets";
import { DynamicSnippetsGenerator as TypeScript } from "@fern-api/typescript-dynamic-snippets";

// src/core/HttpEndpointReferenceParser.ts
var HttpEndpointReferenceParser = class {
  constructor() {
    this.REFERENCE_REGEX = /^(?:(\w+)::)?(GET|POST|PUT|DELETE|PATCH|HEAD)\s(\/\S*)$/;
  }
  validate(reference) {
    const validFormat = this.REFERENCE_REGEX.test(reference);
    if (!validFormat) {
      return { type: "invalid" };
    }
    return { type: "valid" };
  }
  tryParse(reference) {
    const validationResponse = this.validate(reference);
    if (validationResponse.type === "invalid") {
      return void 0;
    }
    const match = reference.match(this.REFERENCE_REGEX);
    if (!(match == null ? void 0 : match[2]) || !(match == null ? void 0 : match[3])) {
      return void 0;
    }
    return {
      namespace: match[1],
      method: match[2],
      path: match[3]
    };
  }
};

// src/EndpointSnippetGenerator.ts
var EndpointSnippetGenerator = class {
  constructor({
    generator,
    endpoint
  }) {
    this.generator = generator;
    this.endpoint = endpoint;
  }
  async generate(request) {
    const _request = request != null ? request : this.resolveDefaultRequestOrThrow();
    return this.generator.generate({
      endpoint: this.endpoint.location,
      baseURL: _request.baseURL,
      environment: _request.environment,
      auth: _request.auth,
      pathParameters: _request.pathParameters,
      queryParameters: _request.queryParameters,
      headers: _request.headers,
      requestBody: _request.requestBody
    });
  }
  generateSync(request) {
    const _request = request != null ? request : this.resolveDefaultRequestOrThrow();
    return this.generator.generateSync({
      endpoint: this.endpoint.location,
      baseURL: _request.baseURL,
      environment: _request.environment,
      auth: _request.auth,
      pathParameters: _request.pathParameters,
      queryParameters: _request.queryParameters,
      headers: _request.headers,
      requestBody: _request.requestBody
    });
  }
  resolveDefaultRequestOrThrow() {
    var _a;
    for (const example of (_a = this.endpoint.examples) != null ? _a : []) {
      return __spreadProps(__spreadValues({}, example), {
        environment: void 0
      });
    }
    throw new Error(`No default example found for endpoint; please specify a request payload`);
  }
};

// src/EndpointProvider.ts
var EndpointProvider = class {
  constructor({
    config,
    language,
    ir
  }) {
    this.config = config;
    this.language = language;
    this.ir = ir;
    this.httpEndpointReferenceParser = new HttpEndpointReferenceParser();
  }
  endpoint(endpoint, _options = {}) {
    const parsedEndpoint = this.parseEndpointOrThrow({ endpoint });
    const generator = this.getGenerator({ ir: this.ir });
    const resolvedEndpoint = this.resolveEndpointOrThrow({
      ir: this.ir,
      parsedEndpoint
    });
    return new EndpointSnippetGenerator({
      generator,
      endpoint: resolvedEndpoint
    });
  }
  getGenerator({
    ir
  }) {
    switch (this.language) {
      case "python": {
        return new Python({ ir, config: this.config });
      }
      case "typescript": {
        return new TypeScript({ ir, config: this.config });
      }
      case "java": {
        return new Java({ ir, config: this.config });
      }
      case "php": {
        return new PHP({ ir, config: this.config });
      }
      case "ruby": {
        return new Ruby({ ir, config: this.config });
      }
      case "csharp": {
        return new CSharp({ ir, config: this.config });
      }
      case "go": {
        return new Go({ ir, config: this.config });
      }
      case "swift": {
        return new Swift({ ir, config: this.config });
      }
      default:
        throw new Error(`Unsupported language: ${this.language}`);
    }
  }
  parseEndpointOrThrow({ endpoint }) {
    const parsedEndpoint = this.httpEndpointReferenceParser.tryParse(endpoint);
    if (parsedEndpoint == null) {
      throw new Error(`Invalid endpoint reference: "${endpoint}"`);
    }
    return parsedEndpoint;
  }
  resolveEndpointOrThrow({
    ir,
    parsedEndpoint
  }) {
    for (const endpoint of Object.values(ir.endpoints)) {
      if (this.parsedEndpointMatches({ endpoint, parsedEndpoint })) {
        return endpoint;
      }
    }
    throw new Error(`Failed to find endpoint identified by "${parsedEndpoint.method} ${parsedEndpoint.path}"`);
  }
  parsedEndpointMatches({
    endpoint,
    parsedEndpoint
  }) {
    return endpoint.location.method === parsedEndpoint.method && endpoint.location.path === parsedEndpoint.path;
  }
};

// src/SnippetResolver.ts
var DEFAULT_CONFIGS = {
  python: config_default5,
  typescript: config_default8,
  java: config_default3,
  php: config_default4,
  ruby: config_default6,
  csharp: config_default,
  go: config_default2,
  swift: config_default7
};
function createDefaultConfig(language) {
  const defaults = DEFAULT_CONFIGS[language];
  if (!defaults) {
    throw new Error(`Unsupported language: ${language}`);
  }
  return structuredClone(defaults);
}
var SnippetResolver = class {
  constructor(args) {
    this.snippetInputs = args.snippetInputs;
  }
  sdk(language, _options = {}) {
    return this.getGeneratorForLanguage({ language });
  }
  getGeneratorForLanguage({ language }) {
    const snippetInput = this.snippetInputs.find((input) => input.language === language);
    if (!snippetInput) {
      throw new Error(`No configuration found for language: ${language}`);
    }
    const config = this.getGeneratorConfigForLanguage({
      language,
      customConfig: snippetInput.ir.generatorConfig
    });
    return new EndpointProvider({
      config,
      language,
      ir: snippetInput.ir
    });
  }
  getGeneratorConfigForLanguage({
    language,
    customConfig
  }) {
    var _a, _b, _c, _d, _e, _f;
    const config = createDefaultConfig(language);
    if (customConfig == null ? void 0 : customConfig.apiName) {
      config.workspaceName = customConfig.apiName;
    }
    if (customConfig == null ? void 0 : customConfig.organization) {
      config.organization = customConfig.organization;
    }
    if (customConfig == null ? void 0 : customConfig.customConfig) {
      config.customConfig = customConfig.customConfig;
    }
    if ((customConfig == null ? void 0 : customConfig.outputConfig) && config.output.mode.type === "github" && customConfig.outputConfig.type === "publish") {
      if (customConfig.outputConfig.value.type === "maven" && ((_a = config.output.mode.publishInfo) == null ? void 0 : _a.type) === "maven") {
        config.output.mode.publishInfo.coordinate = customConfig.outputConfig.value.coordinate;
      } else if (customConfig.outputConfig.value.type === "nuget" && ((_b = config.output.mode.publishInfo) == null ? void 0 : _b.type) === "nuget") {
        config.output.mode.publishInfo.packageName = customConfig.outputConfig.value.packageName;
      } else if (customConfig.outputConfig.value.type === "npm" && ((_c = config.output.mode.publishInfo) == null ? void 0 : _c.type) === "npm") {
        config.output.mode.publishInfo.packageName = customConfig.outputConfig.value.packageName;
      } else if (customConfig.outputConfig.value.type === "pypi" && ((_d = config.output.mode.publishInfo) == null ? void 0 : _d.type) === "pypi") {
        config.output.mode.publishInfo.packageName = customConfig.outputConfig.value.packageName;
      } else if (customConfig.outputConfig.value.type === "rubygems" && ((_e = config.output.mode.publishInfo) == null ? void 0 : _e.type) === "rubygems") {
        config.output.mode.publishInfo.packageName = customConfig.outputConfig.value.packageName;
      } else if (language === "go") {
        config.output.mode.repoUrl = (_f = customConfig.outputConfig.value.repoUrl) != null ? _f : "";
      }
    }
    return config;
  }
};
export {
  SnippetResolver
};
